var React = require('react');

function AreaLogoCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"31.5","cy":"31.5","r":"31.5","style":{"fill":"#FFFFFF"},"key":0}),React.createElement("circle",{"cx":"31.5","cy":"31.5","r":"28.125","style":{"fill":"#1f1f1f"},"key":1}),React.createElement("path",{"d":"M28.958,14.625,18,43.358l4.032,4.032,3.413-9.538H37.608l3.411,9.557,4.366-4.365L34.333,14.625Zm2.576,6.212,4.455,12.481H27.068Z","style":{"fill":"#fff","fillRule":"evenodd"},"key":2})]);
}

AreaLogoCircle.defaultProps = {"viewBox":"0 0 63 63"};

module.exports = AreaLogoCircle;

AreaLogoCircle.default = AreaLogoCircle;
